export default __webpack_public_path__ + "static/media/DarkBlue0007.68f80d41.png";